require('./RASuitabilityTestAnswersInfo.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @utilities
const { FormattedText } = require('core/i18n').i18n;

class RASuitabilityTestAnswersInfo extends React.Component {
    render() {
        return (
            <div className="ra-suitability-test-answers-info">
                <FormattedText value="raSuitabilityTestAnswersInfo-firstParagraph" />
            </div>
        );
    }
}

RASuitabilityTestAnswersInfo.propTypes = {
    email: PropTypes.string.isRequired,
};

module.exports = RASuitabilityTestAnswersInfo;
